import React, { useContext, useState, useEffect } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  getAuth,
} from 'firebase/auth';

import { app } from '../utils/firebase';


const AuthContext = React.createContext();
const myAuth = getAuth(app);

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const signUp = (email, password) => {
    return createUserWithEmailAndPassword(myAuth, email, password);
  };

  const login = (email, password) => {
    return signInWithEmailAndPassword(myAuth, email, password);
  };

  const logout = () => {
    return signOut(myAuth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(myAuth, (user) => {
      console.log();
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    login,
    signUp,
    logout,
  };

  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};
